import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import jwt_decode from "jwt-decode";

import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import { resendEmailLink } from "../../state/slices/auth";
import { useToast } from "../../hooks/useToast";

export default function VerifyAccountHandler() {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const [queryData, setQueryData] = useState(null);
  const [emailSent, setEmailSent] = useState(false);
  const [isAccountVerified, setAccountVerified] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [buttonText, setButtonText] = useState("Click to Resend");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [loader, setLoader] = useState(true);
  const dispatch = useDispatch();
  const { toast } = useToast(3000);

  useEffect(() => {
    if (searchParams) {
      setQueryData(searchParams.get("session_token"));
      const data = decodeUserInfo(searchParams.get("session_token"));
      setUserInfo(data);
      setLoader(false);
    }
  }, []);

  const decodeUserInfo = (tok) => {
    const info = jwt_decode(tok);
    return info;
  };

  const resendHandler = async () => {
    setButtonText("Sending...");
    setButtonDisabled(true);
    try {
      const resp = await dispatch(
        resendEmailLink({
          sessionToken: queryData,
        })
      );
      if (resp.payload.status === true) {
        setEmailSent(true);
      }
      if (resp.payload.message === "Your account is already verified") {
        setAccountVerified(true);
      }
    } catch (error) {
      toast(
        "error",
        error?.message ?? "Something went wrong please try again."
      );
    }
  };

  return (
    <>
      {loader ? (
        <SpinnerIcon className="text-gray-500" />
      ) : (
        <div className="grid min-h-screen gap-2 SignIn sm:grid-cols-8">
          <div className="items-center justify-center hidden h-full rounded-md sm:col-span-2 sm:flex"></div>
          <div className="flex items-center justify-center h-full px-4 rounded-md sm:col-span-4 sm:px-0">
            <div className="w-full sm:max-w-[560px]">
              <div className="w-full py-4 sm:px-4 md:px-0">
                <div className="flex items-center justify-center">
                  <div className="flex items-center justify-center">
                    <div className="w-48">
                      <img
                        src="https://res.cloudinary.com/duqjf9tj1/image/upload/v1639701540/Assets/sfl_bxbwqe.svg"
                        alt="SFL Logo"
                        className="w-full"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {emailSent === false && isAccountVerified === false ? (
                <div class="max-w-xl p-8 text-center text-gray-800 bg-white shadow-xl lg:max-w-3xl rounded-3xl lg:p-12">
                  <div className="space-2">
                    <h5 class="text-2xl text-gray-400 ">
                      Thanks for signing up!{" "}
                    </h5>
                    <p className="text-gray-400">
                      Please check your email inbox and verify your account!
                    </p>
                    <div class="flex justify-center">
                      <svg
                        class="w-32 h-32"
                        viewBox="0 0 50 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M42.2285 0C40.3812 4.92e-05 38.7061 0.741775 37.4785 1.94141H18.4102C18.3787 1.94141 18.3493 1.94909 18.3184 1.95117C18.1298 1.94236 17.9327 1.91521 17.6641 1.97656C17.5086 2.01156 17.3074 2.10876 17.1797 2.28516C17.052 2.46106 17.0156 2.66417 17.0156 2.85547V3.20898C17.0101 3.25944 17 3.30955 17 3.36133V4.11719L17.0156 4.12695V19.9551C17.0156 20.1414 17.0477 20.3306 17.1484 20.502C17.2492 20.6734 17.4182 20.7996 17.5723 20.8613C17.8803 20.9847 18.1304 20.9551 18.3789 20.9551H45.6523C46.0097 20.9551 46.3585 20.8387 46.6152 20.5977C46.872 20.3565 47.0156 19.9997 47.0156 19.627V11.6309C48.2595 10.3975 49.0312 8.69075 49.0312 6.80469C49.0313 3.05339 45.9798 0 42.2285 0ZM42.2285 1C45.4394 1 48.0313 3.59389 48.0312 6.80469C48.0312 10.0156 45.4394 12.6074 42.2285 12.6074C39.0177 12.6074 36.4238 10.0156 36.4238 6.80469C36.4238 3.59389 39.0176 1.0001 42.2285 1ZM42.2285 1.91992C39.5376 1.91992 37.3457 4.11389 37.3457 6.80469C37.3457 9.49559 39.5377 11.6874 42.2285 11.6875C44.9194 11.6875 47.1113 9.49559 47.1113 6.80469C47.1114 4.11389 44.9194 1.91992 42.2285 1.91992ZM42.2285 2.91992C44.379 2.91992 46.1113 4.65429 46.1113 6.80469C46.1113 8.95509 44.3789 10.6875 42.2285 10.6875C40.0781 10.6874 38.3457 8.95509 38.3457 6.80469C38.3457 4.65429 40.0781 2.91992 42.2285 2.91992ZM18.3496 2.95312C18.3775 2.9531 18.3771 2.95312 18.4102 2.95312H36.625C35.8693 4.04923 35.4238 5.37598 35.4238 6.80469C35.4238 8.17802 35.8362 9.45503 36.5391 10.5254L32.2715 13.6211L32.2539 13.6387C32.1417 13.7387 32.0985 13.7439 32.0605 13.7441C32.0226 13.7443 31.9342 13.7282 31.7715 13.6094L18.043 3.61328L18.0156 3.5957V3.27734C18.0495 3.10235 18.1792 2.97857 18.3496 2.95312ZM44.6426 4.63672C44.513 4.63827 44.389 4.69009 44.2969 4.78125L41.1934 7.77148L40.1602 6.77539C40.1131 6.72883 40.0574 6.69206 39.996 6.66721C39.9347 6.64236 39.8691 6.62993 39.8029 6.63064C39.7368 6.63134 39.6714 6.64517 39.6106 6.67132C39.5498 6.69747 39.4949 6.73542 39.4489 6.78298C39.4028 6.83053 39.3667 6.88674 39.3426 6.94835C39.3185 7.00996 39.3068 7.07575 39.3083 7.1419C39.3098 7.20805 39.3244 7.27324 39.3513 7.33371C39.3782 7.39417 39.4167 7.4487 39.4648 7.49414L40.8457 8.82617C40.9389 8.91579 41.0631 8.96586 41.1924 8.96586C41.3217 8.96586 41.4459 8.91579 41.5391 8.82617L44.9902 5.5C45.0632 5.43099 45.1137 5.34161 45.1351 5.2435C45.1565 5.14539 45.1479 5.04311 45.1104 4.94995C45.0729 4.8568 45.0082 4.7771 44.9248 4.72124C44.8413 4.66537 44.743 4.63592 44.6426 4.63672V4.63672ZM18.0156 4.83203L31.1836 14.418C31.4501 14.6121 31.7434 14.7459 32.0664 14.7441C32.3894 14.7441 32.6876 14.5913 32.918 14.3867L37.1523 11.3164C38.3998 12.7173 40.2098 13.6074 42.2285 13.6074C43.6296 13.6074 44.9323 13.18 46.0156 12.4512V19.627C46.0156 19.7646 45.9788 19.8212 45.9297 19.8672C45.8806 19.9132 45.7986 19.9551 45.6523 19.9551H18.3789C18.1652 19.9551 18.0614 19.9415 18.0156 19.9375V4.83203Z"
                          fill="url(#paint0_linear)"
                        />
                        <rect
                          y="5"
                          width="15"
                          height="2"
                          rx="1"
                          fill="#99c95b"
                        />
                        <rect
                          y="11"
                          width="15"
                          height="2"
                          rx="1"
                          fill="#99c95b"
                        />
                        <rect
                          y="8"
                          width="6"
                          height="2"
                          rx="1"
                          fill="#99c95b"
                        />
                        <rect
                          y="15"
                          width="6"
                          height="2"
                          rx="1"
                          fill="#99c95b"
                        />
                        <rect
                          x="8"
                          y="8"
                          width="6"
                          height="2"
                          rx="1"
                          fill="#99c95b"
                        />
                        <rect
                          x="8"
                          y="15"
                          width="6"
                          height="2"
                          rx="1"
                          fill="#99c95b"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear"
                            x1="16.9996"
                            y1="10.4791"
                            x2="47.0156"
                            y2="10.4791"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#99c95b" />
                            <stop offset="1" stop-color="#99c95b" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div className="text-center pt-4">
                      <p className="text-gray-400">
                        Didn&apos;t get a confirmation email. Check your span
                        folder or{" "}
                        <button
                          type="button"
                          className={
                            buttonDisabled
                              ? "py-2 rounded-md cursor-not-allowed opacity-50"
                              : "py-1 border-b-2 cursor-pointer"
                          }
                          disabled={buttonDisabled}
                          onClick={resendHandler}
                        >
                          <span className="font-semibold">{buttonText}</span>
                        </button>
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {emailSent === true && (
                    <div className="p-6 mx-auto my-10 bg-white rounded-md shadow-sm drop-shadow-md">
                      <div className="grid gap-2">
                        <div className=" flex justify-center items-center h-20 ">
                          <svg
                            className="h-20 w-8"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 467.36"
                          >
                            <g>
                              <path
                                fill="#333"
                                d="M58.327 0h254.296c-11.984 13.787-22.844 27.299-32.641 40.444H58.327c-4.929 0-9.415 2.01-12.656 5.227a17.95 17.95 0 00-5.227 12.657v350.705c0 4.868 2.04 9.331 5.288 12.579 3.264 3.263 7.75 5.304 12.595 5.304h395.345c4.815 0 9.286-2.056 12.557-5.327 3.271-3.271 5.326-7.742 5.326-12.556V211.536A1199.255 1199.255 0 00512 194.294v214.739c0 15.995-6.611 30.592-17.173 41.154-10.562 10.562-25.159 17.173-41.155 17.173H58.327c-15.996 0-30.623-6.58-41.193-17.15C6.595 439.671 0 425.082 0 409.033V58.328C0 26.298 26.298 0 58.327 0z"
                              />
                              <path
                                fill="#01A601"
                                d="M137.419 167.477l62.691-.825a10.042 10.042 0 015.427 1.513c12.678 7.329 24.639 15.69 35.789 25.121a243.712 243.712 0 0122.484 21.681c21.972-34.811 48.576-70.325 76.509-103.639 34.552-41.2 71.358-79.245 104.09-108.6a10.045 10.045 0 016.718-2.567l48.071-.039c5.579 0 10.111 4.532 10.111 10.111 0 2.752-1.108 5.259-2.896 7.077-44.311 49.249-89.776 105.68-130.969 163.496-38.09 53.466-72.596 108.194-99.23 159.612-2.553 4.945-8.644 6.894-13.588 4.341a10.07 10.07 0 01-4.693-5.105c-14.582-31.196-32.052-59.924-52.916-85.679-20.887-25.778-45.244-48.645-73.567-68.087-4.593-3.134-5.777-9.423-2.644-14.016 2.002-2.935 5.296-4.479 8.613-4.395z"
                              />
                            </g>
                          </svg>
                        </div>
                        <div className="flex justify-center items-center">
                          <p className="text-center">
                            Email has been sent successfully check your inbox
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                  {isAccountVerified === true && <VerifiedScreen />}
                </>
              )}
            </div>
          </div>
          <div className="items-center justify-center hidden h-full rounded-md sm:col-span-2 sm:flex"></div>
        </div>
      )}
    </>
  );
}

const VerifiedScreen = () => {
  return (
    <div className="bg-white p-8 rounded shadow-md">
      {/* SVG Icon */}
      <div className="flex flex-col items-center justify-between mb-4 space-x-4 space-y-8">
        <h5 class="text-2xl text-gray-400 ">Account is already Verified! </h5>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          shape-rendering="geometricPrecision"
          text-rendering="geometricPrecision"
          image-rendering="optimizeQuality"
          fill-rule="evenodd"
          clip-rule="evenodd"
          viewBox="0 0 391 512"
          height="70"
        >
          <path
            fill="#acaeb0"
            fill-rule="nonzero"
            d="M299.2 200.71v-27.22c0-43.14-24.37-83.95-64.5-101.41a98.16 98.16 0 0 0-39.22-8.16c-13.89 0-27.15 2.91-39.22 8.17-40.15 17.43-64.5 58.28-64.5 101.4v27.22H27.85v-27.22c0-68.54 39.93-132.63 103.43-160.14C151.11 4.75 172.81 0 195.49 0c22.67 0 44.4 4.76 64.24 13.35C323.2 40.83 363.14 105 363.14 173.49v27.22H299.2z"
          />
          <path
            fill="#99c95b"
            d="M26.19 200.71h338.62c14.41 0 26.19 11.79 26.19 26.19v258.91c0 14.4-11.78 26.19-26.19 26.19H26.19C11.77 512 0 500.21 0 485.81V226.9c-.01-14.41 11.78-26.19 26.19-26.19z"
          />
          <path
            fill="#fff"
            d="m144.85 325.75 31.85 30.36 70.47-71.34c5.31-5.38 8.63-9.7 15.16-2.97l21.22 21.73c6.96 6.89 6.61 10.93.04 17.34l-94.77 93.34c-13.86 13.58-11.44 14.41-25.49.47l-54.18-53.9c-2.93-3.16-2.62-6.37.59-9.54l24.62-25.53c3.73-3.93 6.7-3.58 10.49.04z"
          />
        </svg>
        <p className="text-gray-400 text-center">
          Thank you for using our service. Your account has already been
          verified.
        </p>
      </div>
    </div>
  );
};
